import React, { forwardRef, useState, useRef, useContext, useEffect } from 'react';
import gsap from 'gsap';
import helpIcon from '../img/help-large.svg';
import hamburgerIcon from '../img/hamburger.svg';
import logoLarge from '../img/logo-large.svg';
import speakerIconOn from '../img/speaker-on.svg';
import speakerIconOff from '../img/speaker-off.svg';
import HelpModal from './HelpModal';
import { VideoContext } from '../context/VideoContext';

// eslint-disable-next-line no-empty-pattern
const Header = forwardRef(({}, ref) => {

  const { playAudio, setPlayAudio } = useContext(VideoContext);
  const [openMenu, setOpenMenu] = useState(false);
 
  const [open, setOpen] = useState(false);

  const modalRef = useRef();

  const openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    gsap.to(modalRef.current, {
      opacity: 1, duration: .75, ease: "power4.out",
      onStart: () => {
        modalRef.current.style.display = "flex";
        modalRef.current.style.pointerEvents = "auto";
      }
    });
    setOpen(true);

    document.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
      el.setAttribute('tabindex', '-1');
    });

    modalRef.current.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
      el.setAttribute('tabindex', null);
    });

    modalRef.current.focus();
  };

  const clickSpeaker = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (playAudio) {
      setPlayAudio(false);      
    } else {
      setPlayAudio(true);
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      if (typeof window.showVideo === "function") {
        window.showVideo(true);
      } else {
        console.error(`\t window.showVideo is not defined`);
      }
      window.removeEventListener('scroll', handleScroll);
      setOpenMenu(false);
    }
  };

  const clickHamburger = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof window.showMenu === "function") {
      window.showMenu(!openMenu);
      if (!openMenu) {
        window.addEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }
      setOpenMenu(!openMenu);
    } else {
      console.error(`\t window.showMenu is not defined`);
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  };

  return (
    <div ref={ref} className={`header-wrapper fixed z-[9999] top-0 text-white font-bold text-[20px] flex flex-row w-full p-4 pr-0 opacity-0`}>

      <div className="flex justify-start w-1/2">
        <img src={logoLarge} alt="" onClick={scrollToTop} className="block w-[82px] md:w-[140px] cursor-pointer" />
      </div>

      <ul className="flex flex-row justify-end w-1/2 items-center">
        <li className="mr-2">
          <a
            href="/help"
            onClick={openModal}
            onMouseDown={(e) => {e.preventDefault()}}
            className="helpButton block mr-0 mobile:mr-0 cursor-pointer m-auto w-[30px]"
            aria-label="Help"
          >
            <img src={helpIcon} alt="" className="w-full h-auto"/>
          </a>
        </li>
        <li className="mr-6">
          <a href={playAudio ? "/disable-audio" : "/enable-audio"} onClick={clickSpeaker} onMouseDown={(e) => {e.preventDefault()}}>
            <img src={playAudio ? speakerIconOn : speakerIconOff} alt="" className="block mr-0 mobile:mr-0 cursor-pointer m-auto w-[40px]"/>
          </a>
        </li>
        <li>
          <a href="/open-menu" onClick={clickHamburger}>
            <img src={hamburgerIcon} alt="" className="block mr-0 mobile:mr-0 cursor-pointer m-auto w-[57px]"/>
          </a>
        </li>

      </ul>

      <HelpModal 
        ref={modalRef}
        open={open}
        setOpen={setOpen}
      />

    </div>
  );
});

export default Header;
